import { createPinia, PiniaVuePlugin } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Select2 from "vue3-select2-component/src/Select2.vue";

const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: window.sessionStorage,
    auto: true,
  })
);

declare global {
  interface Window {
    daum: any;
  }
}

// app.use(PiniaVuePlugin);
import "@/css/common.css";
createApp(App)
.use(router)
.use(pinia)
.use(PiniaVuePlugin)
.component("Select2", Select2)
.mount("#app");
